module.exports = __webpack_public_path__ + "static/media/resume.b30ccd30.png";